import { DeleteClientCreditCardRequest, ApiResponse } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useDeleteCreditCard() {
  const [deleting, setDeleting] = useState(false);

  async function deleteCreditCard(params: DeleteClientCreditCardRequest): Promise<ApiResponse> {
    try {
      setDeleting(true);
      const res = await api.postDeleteClientCreditCard(params);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setDeleting(false);
    }
  }

  return { deleting, deleteCreditCard };
}
